module.exports = __webpack_public_path__ + "static/media/banner-fix.1c6f5506.jpg";